<template>
  <div>
    <div>
      <b-modal
        ref="openModal"
        class="filterDateModal"
        scrollable
        size="sm"
        title="Filtros para exportação"
        :ok-disabled="true"
        @ok="modalOk"
      >
        <!-- <label>Filtros para exportação</label> -->
        <label>Tipo de exportação:</label>
        <b-form-select
          v-model="optionsExport"
          id="optionsExport"
          :options="optionsExportPdf"
        >
        </b-form-select>
        <div v-for="field in fields" :key="field.key" class="vertical-align">
          <!-- {{field}} -->
          <div v-if="field.filterType == 'dateRange'">
            <b-form-group
              :label="field.label + ' (inicio)'"
              :label-for="field.filterKey"
            >
              <b-form-input
                :id="field.filterKey"
                type="date"
                v-model="tableFilters[field.filterKeyBegin]"
              />
            </b-form-group>
            <b-form-group
              :label="field.label + ' (fim)'"
              :label-for="field.filterKey"
            >
              <b-form-input
                :id="field.filterKey"
                type="date"
                v-model="tableFilters[field.filterKeyEnd]"
              />
            </b-form-group>
          </div>
          <div v-else-if="tableFilters[field.filterKey] != null">
            <b-form-group :label="field.label" :label-for="field.filterKey">
              <b-form-input
                :id="field.filterKey"
                v-model="tableFilters[field.filterKey]"
                :placeholder="'Buscar por ' + field.label"
              />
            </b-form-group>
          </div>
        </div>

        <b-form-group
          label="Registros a exportar"
          label-for="paginationOptions"
        >
          <b-form-select
            v-model="paginationPerPage"
            id="paginationOptions"
            :options="paginationOptions"
          >
          </b-form-select>
        </b-form-group>

        <template #modal-footer="{ ok, cancel }">
          <div class="right">
            <b-button variant="green" @click="ok()" :disabled="isExporting">
              {{ $t("geral.confirm") }}
            </b-button>
            <b-button class="ml-2" variant="danger" @click="cancel()">
              {{ $t("geral.cancel") }}
            </b-button>
          </div>
        </template>
      </b-modal>

      <b-button size="sm" @click="modalOpen">Exportar CSV</b-button>

      <!-- <pre class="language-json"><code>{{ fields  }}</code></pre> -->
      <!-- <pre class="language-json"><code>{{ tableFilters  }}</code></pre> -->
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    fields: Array,
    tableFilters: Object,
    paginationPerPage: Number,
  },
  data: function () {
    return {
      isExporting: false,
      optionsExportPdf: [
        { value: 0, text: "Apenas campos ativos" },
        { value: 1, text: "Exportação completa" },
      ],
      optionsExport: 0,
      paginationOptions: [5, 10, 25, 50, 100, 150, 500, 1000, 2500, 5000],
    };
  },

  computed: {
    getFilterFill: {
      get: function () {
        return this.dateFill;
      },
      set: function (value) {
        this.$emit("update:dateBegin", value);
        this.$emit("update:dateEnd", value);
      },
    },
    getFilterBegin: {
      get: function () {
        return this.dateBegin;
      },
      set: function (value) {
        this.$emit("update:dateBegin", value);
      },
    },
    getFilterEnd: {
      get: function () {
        return this.dateEnd;
      },
      set: function (value) {
        this.$emit("update:dateEnd", value);
      },
    },
    getFilterOption: {
      get: function () {
        return this.optionFilterDate;
      },
      set: function (value) {
        this.$emit("update:optionFilterDate", value);
      },
    },
  },
  methods: {
    modalOpen() {
      this.$refs.openModal.show();
    },
    modalOk(bvModalEvt) {
      bvModalEvt.preventDefault();

      let apiFilter = {
        currentPage: 1,
        perPage: this.paginationPerPage,
        checklistId: this.tableFilters.checklistId,
        formName: this.tableFilters.formName,
        formSearchKey: this.tableFilters.formSearchKey,
        dateFill: this.tableFilters.dateFill,
        fillDateBegin: this.tableFilters.dateBegin,
        fillDateEnd: this.tableFilters.dateEnd,
        fillUserName: this.tableFilters.userFillName,
        checklistStatus: this.tableFilters.checklistStatus,
      };

      this.isExporting = true;

      this.$apiChecklist
        .request({
          url: "/checklist/exporttocsv/" + this.optionsExport,
          method: "POST",
          data: apiFilter,
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.isExporting = false;
          this.$refs.openModal.hide("modal-prevent-closing");
        });
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>

